import { createCoords as O, rectToClientRect as _, round as F, floor as x, max as q, min as D } from "./index123.js";
import { getOverflowAncestors as B, isElement as L, getWindow as b, getFrameElement as I, getComputedStyle as M, getDocumentElement as $, isHTMLElement as V, isWebKit as N } from "./index124.js";
function S(t) {
  const e = M(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const s = V(t), c = s ? t.offsetWidth : n, o = s ? t.offsetHeight : i, r = F(n) !== c || F(i) !== o;
  return r && (n = c, i = o), {
    width: n,
    height: i,
    $: r
  };
}
function z(t) {
  return L(t) ? t : t.contextElement;
}
function C(t) {
  const e = z(t);
  if (!V(e))
    return O(1);
  const n = e.getBoundingClientRect(), {
    width: i,
    height: s,
    $: c
  } = S(e);
  let o = (c ? F(n.width) : n.width) / i, r = (c ? F(n.height) : n.height) / s;
  return (!o || !Number.isFinite(o)) && (o = 1), (!r || !Number.isFinite(r)) && (r = 1), {
    x: o,
    y: r
  };
}
const U = /* @__PURE__ */ O(0);
function K(t) {
  const e = b(t);
  return !N() || !e.visualViewport ? U : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function j(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== b(t) ? !1 : e;
}
function W(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect(), c = z(t);
  let o = O(1);
  e && (i ? L(i) && (o = C(i)) : o = C(t));
  const r = j(c, n, i) ? K(c) : O(0);
  let a = (s.left + r.x) / o.x, f = (s.top + r.y) / o.y, g = s.width / o.x, p = s.height / o.y;
  if (c) {
    const w = b(c), h = i && L(i) ? b(i) : i;
    let m = w, u = I(m);
    for (; u && i && h !== m; ) {
      const v = C(u), l = u.getBoundingClientRect(), d = M(u), R = l.left + (u.clientLeft + parseFloat(d.paddingLeft)) * v.x, E = l.top + (u.clientTop + parseFloat(d.paddingTop)) * v.y;
      a *= v.x, f *= v.y, g *= v.x, p *= v.y, a += R, f += E, m = b(u), u = I(m);
    }
  }
  return _({
    width: g,
    height: p,
    x: a,
    y: f
  });
}
function H(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function G(t, e) {
  let n = null, i;
  const s = $(t);
  function c() {
    var r;
    clearTimeout(i), (r = n) == null || r.disconnect(), n = null;
  }
  function o(r, a) {
    r === void 0 && (r = !1), a === void 0 && (a = 1), c();
    const f = t.getBoundingClientRect(), {
      left: g,
      top: p,
      width: w,
      height: h
    } = f;
    if (r || e(), !w || !h)
      return;
    const m = x(p), u = x(s.clientWidth - (g + w)), v = x(s.clientHeight - (p + h)), l = x(g), R = {
      rootMargin: -m + "px " + -u + "px " + -v + "px " + -l + "px",
      threshold: q(0, D(1, a)) || 1
    };
    let E = !0;
    function T(A) {
      const y = A[0].intersectionRatio;
      if (y !== a) {
        if (!E)
          return o();
        y ? o(!1, y) : i = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      y === 1 && !H(f, t.getBoundingClientRect()) && o(), E = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...R,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, R);
    }
    n.observe(t);
  }
  return o(!0), c;
}
function X(t, e, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: c = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: r = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = i, f = z(t), g = s || c ? [...f ? B(f) : [], ...e ? B(e) : []] : [];
  g.forEach((l) => {
    s && l.addEventListener("scroll", n, {
      passive: !0
    }), c && l.addEventListener("resize", n);
  });
  const p = f && r ? G(f, n) : null;
  let w = -1, h = null;
  o && (h = new ResizeObserver((l) => {
    let [d] = l;
    d && d.target === f && h && e && (h.unobserve(e), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var R;
      (R = h) == null || R.observe(e);
    })), n();
  }), f && !a && h.observe(f), e && h.observe(e));
  let m, u = a ? W(t) : null;
  a && v();
  function v() {
    const l = W(t);
    u && !H(u, l) && n(), u = l, m = requestAnimationFrame(v);
  }
  return n(), () => {
    var l;
    g.forEach((d) => {
      s && d.removeEventListener("scroll", n), c && d.removeEventListener("resize", n);
    }), p == null || p(), (l = h) == null || l.disconnect(), h = null, a && cancelAnimationFrame(m);
  };
}
export {
  X as autoUpdate,
  B as getOverflowAncestors
};
